import fetchDocumentClassifications from './fetchDocumentClassifications';
import fetchDocumentExtractTemplates from './fetchDocumentExtractTemplates';

export default {
  fetchDocumentClassifications,
  fetchDocumentExtractTemplates,
};